module.exports = {

    props: {
        data: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            field_audit: this.data,
            project: this.data.project,
            form: {}
        }
    },

    created() {
        if (this.project) {
            this.fetchChecklistData();
        }

        App.bus.$on('auditable-project-set', event => {
            console.log('fetch auditable project info')
            this.project = event.project
            this.fetchChecklistData()
        })
    },

    methods: {

        updateProject(project) {
            this.field_audit['project'] = project;
        },

        fileUploadedEvent() {
            App.bus.$emit('auditable-file-uploaded')
        },

        saveChecklist() {
            App.request()
                .post(`/field-audits/${this.field_audit.id}/checklist/save`, {form: this.form.originalData})
                .then(response => {

                })
                .catch(errors => {
                    Alert.error(errors.first());
                })
        },

        fetchChecklistData() {
            App.request()
                .get(`/field-audits/${this.field_audit.id}/checklist/create-json/${this.project.id}`)
                .then(response => {
                    this.form = new Form(response.data);
                })
                .catch(errors => console.log(errors))
        }
    },
}
